/**
 * Admin — Analytics page — /admin/analytics
 *
 * Placeholder — see AdminNav for the full list of admin sections.
 */
import React from 'react';
import { AdminPageShell } from '../_components/AdminPageShell';

export const AdminAnalyticsPage: React.FC = () => (
  <AdminPageShell title="Analytics">
    <div className="text-center py-12 text-gray-500">
      System analytics coming soon
    </div>
  </AdminPageShell>
);
